export const TIME_AVAILABILITY_TYPES = {
  HORIZONTAL: 'horizontal',
  HORIZONTAL_WITH_DATE: 'horizontalWithDate',
  HORIZONTAL_SEARCH: 'horizontalSearch',
  HORIZONTAL_SEARCH_REFRESH: 'horizontalSearchRefresh',
  HORIZONTAL_EDIT_RESERVATION: 'horizontalEditReservation',
  HORIZONTAL_VENUE_DETAILS_PAGE_DESKTOP: 'horizontalVenueDetailsPageDesktop',
};
